/**
 * Portal invite UI guards (client contacts).
 */

export function contactHasActiveInvite(contact) {
  return contact?.invite === true;
}

export function isInvitedContactEmailChange(contact, nextEmail) {
  if (!contactHasActiveInvite(contact)) return false;
  const current = String(contact?.email || "").trim().toLowerCase();
  const next = String(nextEmail || "").trim().toLowerCase();
  return Boolean(current && next && current !== next);
}

export function canSendPortalInviteToContact(contact, draftEmail) {
  if (!contact) return false;
  const email = draftEmail ?? contact?.email;
  return !isInvitedContactEmailChange(contact, email);
}
